import React , { useState , useEffect } from 'react'
import { ListGroupItem } from 'reactstrap'
import {Input} from 'reactstrap'

function Web_Link_List({ele,onClick_Select_or_Deselect_particular, checkedAll , delete_web_links ,   setcheckedAll , seleted_links }) {
  

    const [check, setcheck] = useState(false )


    useEffect(() => {
   
        
        
       setcheck(checkedAll)
    }, [checkedAll  , setcheckedAll])



    // useEffect(()=>{
        
     
    //   // setcheck(seleted_links.includes(ele))

    //   console.log(seleted_links)
        

    // },[seleted_links])



    useEffect(() => {


      setcheck(ele.Uploaded_To_VectorDB)

    }, [ele.Uploaded_To_VectorDB])
    


    


    




    const onClick_check_box=(e)=>{
        onClick_Select_or_Deselect_particular(e, ele)
    }
    


  return (
    <ListGroupItem
                   
                           className="d-flex justify-content-between align-items-center"
                         >
                           <div className="chek_name">
                             <Input
                               className="form-check-input me-1"
                               type="checkbox"
                               checked={check}
                               onChange={(e)=>{
                                    setcheck(e.target.checked);
                                    onClick_check_box(e)
                               }}
                             />
                             <span className="text-muted">
                               {ele.Url_Link}
                             </span>
                           </div>
                           <span className="dedt">
                             <span>{ele.Url_Char_Count || ele.page_length} characters</span>
                             <span onClick={()=>{
                                delete_web_links(ele);
                             }}  className="red">
                               <i className="ri-delete-bin-line"></i>
                             </span>
                           </span>
                         </ListGroupItem>
  )
}

export default Web_Link_List